import { Button, Modal } from "flowbite-react"
import React from "react"

import CustomerOtpVerificationForm, {
  CustomerOtpVerificationFormProps,
} from "./CustomerOtpVerificationForm"

interface CustomerOtpVerificationModalProps extends CustomerOtpVerificationFormProps {
  show: boolean
  handleClose: () => void
  enableSkipOtpVerification?: boolean
  handleSkipOtp?: () => void
  isRedirectEnabled?: boolean
  isIntegratedPage?: boolean
}

const CustomerOtpVerificationModal = ({
  show,
  handleClose,
  enableSkipOtpVerification = false,
  handleSkipOtp,
  ...rest
}: CustomerOtpVerificationModalProps) => {
  if (!show) return null
  return (
    <Modal show={show} onClose={handleClose} size={"xl"} className={"z-50"}>
      <Modal.Header>Verification</Modal.Header>
      <Modal.Body>
        <div className={"px-6 pt-5 pb-6"}>
          <CustomerOtpVerificationForm {...rest} />
        </div>
        <div className={"flex items-center justify-between bg-whiteBlack-100 pr-6 pl-2 py-3"}>
          {enableSkipOtpVerification ? (
            <Button size={"md"} type={"button"} color={"ghost"} onClick={handleSkipOtp}>
              Skip
            </Button>
          ) : (
            <div />
          )}
          <Button
            outline
            className={"border-primary-600 text-primary-600"}
            size={"md"}
            onClick={() => {
              handleClose()
            }}
          >
            Cancel
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default CustomerOtpVerificationModal
